import {validate_email} from 
    "./validate_email.js";

import {validate_alphanumeric} from 
    "./validate_alphanumeric.js";

import {validate_numbers} from 
    "./validate_numbers.js";    


export function validateValueType(theValue, theValueType){

    switch(theValueType){

        case "email": return validate_email(theValue);
            break;

        case "alphanumericOnly": return validate_alphanumeric(theValue);
            break;

        case "numbers": return validate_numbers(theValue);
            break;

        default : return theValue;
            break;
    };
    
};